class PredictiveSearchResults extends HTMLElement {
  connectedCallback() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.update = this.update.bind(this);
    this.conditionallyCloseSearchBarAndResults =
      this.conditionallyCloseSearchBarAndResults.bind(this);

    this.predictiveSearchBar = document.querySelector(
      '[data-predictive-search-bar]'
    );
    this.mainContent = document.querySelector('#MainContent');
  }

  /**
   * Updates the search results with the given html
   * @param {HTMLElement} html - the html to update the search results with
   */
  update(html) {
    this.innerHTML = html;
    this.open();
  }

  /**
   * Opens search panel
   * @return {void}
   */
  open() {
    // If already open we can return early
    if (this.ariaHidden == 'false') return;
    this.ariaHidden = false;
    document.body.classList.add('predictive-search-open');
    this.predictiveSearchBar.classList.add('search-results-open');
    this.addCloseOnClickedOutsideListener();
    // If mega menu is open then close out to see predictive search results
    this.closeMegaMenu();
  }

  /**
   * Closes the search panel
   * @return {void}
   */
  close() {
    document.body.classList.remove('predictive-search-open');
    this.ariaHidden = true;
    this.mainContent.removeEventListener(
      'click',
      this.conditionallyCloseSearchBarAndResults
    );

    setTimeout(() => {
      this.predictiveSearchBar.classList.add('search-results-open');
    }, 750);
  }

  /**
   * Closes the search bar when a click is outside the search results
   * @param {event} event
   */
  conditionallyCloseSearchBarAndResults(event) {
    if (event.target.closest('[data-predictive-search-results]') === null) {
      this.close();
      this.predictiveSearchBar.closeSearchBar();
    }
  }

  /**
   * Closes the search panel when clicked outside
   * @return {void}
   */
  addCloseOnClickedOutsideListener() {
    this.mainContent.addEventListener(
      'click',
      this.conditionallyCloseSearchBarAndResults
    );
  }

  /**
   * Closes the mega menu when predictive search begins
   * @return {void}
   */
  closeMegaMenu() {
    const megaMenuContainer = document.querySelector(
      '[data-mega-menu-container]'
    );

    megaMenuContainer.classList.remove('active');

    this.menuItems = document.querySelectorAll('[data-mega-menu]');

    for (const menuItem of this.menuItems) {
      menuItem.classList.remove('active');
    }

    const hamburgerElement = document.querySelector('hamburger-element');
    hamburgerElement.classList.remove('active');
  }
}

customElements.get('predictive-search-results') ||
  customElements.define('predictive-search-results', PredictiveSearchResults);
